import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.86 9.61c0-.923-.184-1.839-.542-2.697a7.1 7.1 0 0 0-1.556-2.311A7.3 7.3 0 0 0 12.4 3.037a7.4 7.4 0 0 0-5.618 0A7.3 7.3 0 0 0 4.42 4.602a7.1 7.1 0 0 0-1.556 2.311 7 7 0 0 0 0 5.392 7.1 7.1 0 0 0 1.556 2.312 7.3 7.3 0 0 0 2.362 1.564 7.4 7.4 0 0 0 5.618 0 7.3 7.3 0 0 0 2.362-1.564 7.1 7.1 0 0 0 1.556-2.312 7 7 0 0 0 .542-2.696m2.322 0a9.6 9.6 0 0 1-.742 3.707 9.6 9.6 0 0 1-1.246 2.145l6.435 6.386c.47.467.497 1.253.06 1.756a1.11 1.11 0 0 1-1.642.064l-6.544-6.497a9.6 9.6 0 0 1-2.27 1.328 9.58 9.58 0 0 1-12.49-5.182A9.63 9.63 0 0 1 2.84 2.782 9.59 9.59 0 0 1 13.234.719a9.6 9.6 0 0 1 5.206 5.182 9.6 9.6 0 0 1 .742 3.708"
    }, null, -1)
  ]))]))
}
export default { render: render }